export const testimonials = [
  {
    id: 1,
    quote: "Before OST-C, I had no idea where to start. Within six months of their vocational program, I had my certification, a resume I was proud of, and a full-time job in logistics. They didn't just train me — they believed in me.",
    name: "DeShawn M.",
    detail: "Vocational Skills Training Graduate",
    outcome: "Hired Full-Time in 6 Months",
  },
  {
    id: 2,
    quote: "The life skills program completely changed how I approach every day. I learned how to budget, how to communicate professionally, and how to advocate for myself. I went from uncertainty to confidence — and then to a career.",
    name: "Yolanda P.",
    detail: "Life Skills Development Graduate",
    outcome: "Stable Employment & Independence",
  },
  {
    id: 3,
    quote: "Coming home after incarceration felt impossible. OST-C's reintegration program gave me structure, support, and a real path forward. I got job-ready, got placed, and I've been employed for over a year now. This program saved my life.",
    name: "Marcus J.",
    detail: "Community Reintegration Program Graduate",
    outcome: "1+ Year Continuous Employment",
  },
  {
    id: 4,
    quote: "I had the skills but didn't know how to present myself in the job market. OST-C's job readiness coaching transformed my interviews. I landed my first professional role within three weeks of completing the program.",
    name: "Tanya R.",
    detail: "Job Readiness & Career Development Graduate",
    outcome: "Placed in 3 Weeks After Graduation",
  },
];
